import { TreeSelectProps, RefTreeSelectType } from './interface';

import TreeSelect from './tree-select';

export default TreeSelect;

export { TreeSelectProps, RefTreeSelectType };
